var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92987 3.16602H4.04676C3.56142 3.16602 3.16797 3.55946 3.16797 4.0448C3.16797 8.89822 7.10244 12.8327 11.9558 12.8327C12.4412 12.8327 12.8346 12.4392 12.8346 11.9539V10.0708L10.7632 8.68983L9.68912 9.76391C9.50256 9.95047 9.22377 10.0085 8.98937 9.8874C8.59183 9.68204 7.94673 9.29616 7.31083 8.68983C6.65976 8.06904 6.27829 7.40011 6.08683 6.99532C5.97953 6.76847 6.04165 6.50662 6.21909 6.32918L7.31083 5.23744L5.92987 3.16602Z",
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.ad3118d1e5aafd44afeba40ffa3ee460.svg";
export { ForwardRef as ReactComponent };